module.exports = __webpack_public_path__ + "media/images/bg-services-a482d47778f2b58c88e753f58aa37e83.jpg";